<div *ngIf="vm$ | async as vm">
  <div *ngFor="let content of vm.response?.contents" [ngSwitch]="content.type">
    <lib-survey-page-logo
      *ngSwitchCase="EvaluationContentType.confirmation"
      [title]="content.value | safeHtml"
    >
      <img src="/surveys-assets/images/check.svg" />
    </lib-survey-page-logo>

    <div
      *ngSwitchCase="EvaluationContentType.content"
      [innerHTML]="content.value | safeHtml"
      class="lib-evaluate-response__content survey__inner_html"
    ></div>

    <div
      *ngSwitchCase="EvaluationContentType.restartButton"
      class="lib-evaluate-response__buttons-row"
    >
      <button mat-raised-button color="primary" (click)="restart()">
        <mat-icon>autorenew</mat-icon>
        {{ content.value ?? 'Nouveau questionnaire' }}
      </button>
    </div>
  </div>
</div>
